export const VERSION = 'v2024.04.22.3'
